import { useLocation, useNavigate } from "react-router-dom";
import PageHeader from "../../component/header";
import {
  Box,
  Button,
  Grid,
  Card,
  CardContent,
  CardHeader,
  TextField,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { getToast } from "../../common/utils";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useApi, useDirect } from "../../hooks";
import ReusableField from "../../component/fields";
import { apiBlogs, method } from "../../apiPath";
import keyNames from "../../keyName";
import FileUploader from "../../common/FileUploader";
import { Switch, FormControlLabel } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import IconButton from "@mui/material/IconButton";

// import {
//   EditorProvider,
//   Editor,
//   Toolbar,
//   BtnBold,
//   BtnItalic,
//   BtnUnderline,
//   BtnBulletList,
//   BtnNumberedList,
//   BtnLink,
// } from "react-simple-wysiwyg";
import {
  EditorProvider,
  Editor,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnBulletList,
  BtnNumberedList,
  BtnUndo,
  BtnRedo,
  BtnClearFormatting,
  BtnStyles,
  Separator,
  HtmlButton,
  BtnLink,
} from "react-simple-wysiwyg";

const { get, post, put } = method;
const staticCategories = ["category1", "category2"];

function AddBlog() {
  const hitApi = useApi();
  const navigate = useNavigate();
  const { state } = useLocation();
  const directDispatch = useDirect();
  const storeData = useSelector((state) => state.mainReducer);
  const { isLoading, blogData, extra } = storeData;
  // const BtnHeading = createDropdown("Heading", [
  //   ["Heading 1", () => document.execCommand("formatBlock", true, "h1")],
  //   ["Heading 2", () => document.execCommand("formatBlock", false, "h2")],
  //   ["Paragraph", () => document.execCommand("formatBlock", false, "p")],
  // ]);

  const [description, setDescription] = useState(state?.description || "");
  const [metaDescription, setMetaDescription] = useState(
    state?.meta_description || ""
  );
  const [thumbnail, setThumbnail] = useState(state?.thumbnail || "");
  const [image, setImage] = useState(state?.image || "");
  const [metaImage, setMetaImage] = useState(state?.meta_image || "");
  const [isActive, setIsActive] = useState(state?.isActive ?? true);
  const [endPoint, setEndPoint] = useState({
    path: apiBlogs,
    method: post,
    type: state === "add" ? "prepend" : "edit",
  });
  const [openLinkModal, setOpenLinkModal] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [linkText, setLinkText] = useState("");

  const [selectionRange, setSelectionRange] = useState(null);

  const [slug, setSlug] = useState(state?.slug || "");
  const generateSlug = (title) => {
    return title
      .trim()
      .split(/\s+/)
      .slice(0, 4) // take first 4 words
      .join("-") // join with dashes
      .toLowerCase()
      .replace(/[^a-z0-9\-]/g, ""); // remove special chars
  };

  const btn = {
    back: () => navigate("/app/Blogs"),
    show: false,
    text: "Save & Publish",
    type: "contained",
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      category: state?.category || "",
    },
  });
  useEffect(() => {
    const subscription = watch((value, { name }) => {
      if (name === "title" && value.title) {
        setSlug(generateSlug(value.title));
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  const allowedImageExts = [".png", ".jpg", ".jpeg", ".webp"];
  const isValidImageUrl = (url) => {
    const lower = (url || "").toLowerCase();
    return allowedImageExts.some((ext) => lower.endsWith(ext));
  };
  // const formatToIndiaDate = (dateString) => {
  //   if (!dateString) return dateString;
  //   const [year, month, day] = dateString.split("-");
  //   return `${year}-${parseInt(day)}-${parseInt(month)}`;
  // };
  const onSubmit = (values) => {
    if (metaImage && !isValidImageUrl(metaImage)) {
      setError("meta_image", {
        type: "manual",
        message: "Image format not supported",
      });
      return;
    }
    if (thumbnail && !isValidImageUrl(thumbnail)) {
      setError("thumbnail", {
        type: "manual",
        message: "Image format not supported",
      });
      return;
    }
    if (image && !isValidImageUrl(image)) {
      setError("image", {
        type: "manual",
        message: "Image format not supported",
      });
      return;
    }
    const finalData = {
      ...values,
      slug,
      description,
      meta_description: metaDescription,
      thumbnail,
      image,
      meta_image: metaImage,
      isActive,
      // date: formatToIndiaDate(values.date),
    };
    const isUniqueSlug = async (slug) => {
      try {
        const toast = getToast("error");
        const res = hitApi(
          `${apiBlogs}/checkslug?slug=${encodeURIComponent(slug)}`,
          null,
          get,
          keyNames.slugUniquedata,
          toast
        );

        return res?.data?.isAvailable;
      } catch (err) {
        getToast("error", "Failed to check slug");
        return false;
      }
    };

    const unique = isUniqueSlug(slug);
    if (!unique) {
      // getToast("error", "Slug already exists, try changing the title");

      return;
    }
    const toast = getToast("success");
    hitApi(
      endPoint.path,
      finalData,
      endPoint.method,
      keyNames.blogData,
      toast,

      {
        type: endPoint.type,
        isNavigate: true,
      }
    );
  };
  const handleThumbnailUpload = (url) => {
    setThumbnail(url);
  };
  useEffect(() => {
    if (state && state !== "add") {
      setEndPoint({
        path: `${apiBlogs}/${state._id}`,
        method: put,
        type: "edit",
      });

      setValue("title", state.title || "");
      setValue("subTitle", state.subTitle || "");
      setValue("date", state.date?.substring(0, 10) || "");
      setValue("category", state.category || "");
      setValue("meta_title", state.meta_title || "");
      setDescription(state.description || "");
      setMetaDescription(state.meta_description || "");
      setThumbnail(state.thumbnail || "");
      setImage(state.image || "");
      setMetaImage(state.meta_image || "");
    }
  }, [state, setValue]);

  useEffect(() => {
    if (blogData === null) {
      hitApi(apiBlogs, null, get, keyNames.blogData, getToast("error"));
    }
  }, [blogData, hitApi]);

  useEffect(() => {
    if (extra?.isNavigate) {
      navigate("/app/blogs");
    }
    return () => directDispatch(null, keyNames.extra);
  }, [extra, directDispatch, navigate]);

  const handleOpenLinkModal = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      setSelectionRange(range);
      setLinkText(range.toString());
      setOpenLinkModal(true);
    }
  };

  const handleInsertLink = () => {
    if (!linkUrl) return;

    if (!linkUrl.startsWith("http://") && !linkUrl.startsWith("https://")) {
      alert("Please enter a valid URL starting with http:// or https://");
      return;
    }

    if (selectionRange) {
      const anchor = document.createElement("a");
      anchor.href = linkUrl;
      anchor.target = "_blank";
      anchor.rel = "noopener noreferrer";
      anchor.textContent = linkText || selectionRange.toString(); // use linkText if provided

      selectionRange.deleteContents();
      selectionRange.insertNode(anchor);

      setOpenLinkModal(false);
      setLinkUrl("");
      setLinkText("");
    }
  };

  useEffect(() => {
    const editorEl = document.querySelector(".rsw-ce");
    console.log("editorEl:", editorEl);
    if (editorEl) {
      editorEl.querySelectorAll("a").forEach((link) => {
        link.setAttribute("target", "_blank");
        link.setAttribute("rel", "noopener noreferrer");
      });
    }
  }, [description]);

  return (
    <>
      <PageHeader title={state?._id ? "Edit Blog" : "Add New Blog"} btn={btn} />

      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{ mt: 3 }}
      >
        {/* Meta Section */}
        <Card sx={{ mb: 4, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title="Meta Section" />
          <CardContent>
            <Grid container spacing={3}>
              <Grid item size={{ xs: 12, md: 12 }}>
                <Typography sx={{ mb: 1 }}>Meta Title</Typography>
                <TextField
                  label="Meta Title"
                  fullWidth
                  {...register("meta_title")}
                />
              </Grid>

              <Grid item size={{ xs: 12, md: 6 }}>
                <Card elevation={1} sx={{ p: 2 }}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 3 }}
                  >
                    <FileUploader
                      url={metaImage}
                      type="blog_meta_image"
                      urlType="image"
                      requiredWidth={1200}
                      requiredHeight={630}
                      onFileUpload={(url) => {
                        setMetaImage(url);
                        clearErrors("meta_image");
                      }}
                      onInvalidFile={(msg) =>
                        setError("meta_image", {
                          type: "manual",
                          message: msg || "Image format not supported",
                        })
                      }
                      showPreview={false}
                      buttonText="Upload Image"
                    />
                    <ReusableField
                      label="Meta Image"
                      name="meta_image"
                      type="text"
                      value={metaImage}
                      onChange={(e) => setMetaImage(e.target.value)}
                      fullWidth={true}
                      error={!!errors.meta_image}
                      helperText={
                        errors.meta_image?.message || (
                          <span>
                            <span style={{ color: "#d32f2f" }}>*</span> Meta
                            Image size: (1200 x 630) px
                          </span>
                        )
                      }
                    />
                  </Box>
                </Card>
              </Grid>

              <Grid item size={{ md: 6, xs: 12 }}>
                <Typography sx={{ mb: 1 }}>Meta Description</Typography>
                <TextField
                  label="Meta Description"
                  multiline
                  rows={4}
                  fullWidth
                  value={metaDescription}
                  onChange={(e) => setMetaDescription(e.target.value)}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        {/* Blog Details */}
        <Card sx={{ mb: 4, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title="Blog Details" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item size={{ xs: 12, md: 4 }}>
                <TextField
                  label="Title"
                  fullWidth
                  {...register("title", { required: "Title is required" })}
                  error={!!errors.title}
                  helperText={errors.title?.message}
                />
              </Grid>
              <Grid item size={{ xs: 12, md: 4 }}>
                <TextField
                  label="Slug"
                  fullWidth
                  value={slug}
                  onChange={(e) => setSlug(e.target.value)}
                  helperText={errors.slug?.message}
                  error={!!errors.slug}
                  disabled={state && state !== "add"}
                />
              </Grid>

              <Grid item size={{ xs: 12, md: 4 }}>
                <TextField
                  label="Sub Title"
                  fullWidth
                  {...register("subTitle", {
                    required: "Sub Title is required",
                  })}
                  error={!!errors.subTitle}
                  helperText={errors.subTitle?.message}
                />
              </Grid>

              <Grid item size={{ xs: 12, md: 4 }}>
                <TextField
                  label="Date"
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  {...register("date", { required: "Date is required" })}
                  error={!!errors.date}
                  helperText={errors.date?.message}
                />
              </Grid>

              <Grid item size={{ xs: 12, md: 4 }}>
                <FormControl fullWidth error={!!errors.category}>
                  <InputLabel id="demo-simple-select-label">
                    Category
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={watch("category") || ""}
                    onChange={(e) => setValue("category", e.target.value)}
                    {...register("category", {
                      required: "Category is required",
                    })}
                  >
                    {staticCategories.map((cat) => (
                      <MenuItem key={cat} value={cat}>
                        {cat.charAt(0).toUpperCase() + cat.slice(1)}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item size={{ xs: 12, md: 4 }}>
                <Card elevation={2} sx={{ px: 3, py: 1 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Switch
                          checked={isActive}
                          onChange={(e) => setIsActive(e.target.checked)}
                          color="primary"
                        />
                      }
                      label="Is Active"
                    />
                  </Box>
                </Card>
              </Grid>

              <Grid item size={{ xs: 12, md: 6 }}>
                <Card elevation={1} sx={{ p: 2 }}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 3 }}
                  >
                    <Typography>Thumbnail</Typography>
                    <FileUploader
                      url={thumbnail}
                      type="blog_thumbnail"
                      urlType="image"
                      requiredWidth={300}
                      requiredHeight={200}
                      onFileUpload={(url) => {
                        handleThumbnailUpload(url);
                        clearErrors("thumbnail");
                      }}
                      onInvalidFile={(msg) =>
                        setError("thumbnail", {
                          type: "manual",
                          message: msg || "Image format not supported",
                        })
                      }
                      showPreview={false}
                      buttonText="Upload Image"
                    />
                    <ReusableField
                      label="Thumbnail URL"
                      name="thumbnail"
                      type="text"
                      value={thumbnail}
                      onChange={(e) => setThumbnail(e.target.value)}
                      fullWidth={true}
                      error={!!errors.thumbnail}
                      helperText={
                        errors.thumbnail?.message || (
                          <span>
                            <span style={{ color: "#d32f2f" }}>*</span>{" "}
                            Thumbnail size: (300 x 200) px
                          </span>
                        )
                      }
                    />
                  </Box>
                </Card>
              </Grid>
              <Grid item size={{ xs: 12, md: 6 }}>
                <Card elevation={1} sx={{ p: 2 }}>
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 3 }}
                  >
                    <Typography>Image</Typography>
                    <FileUploader
                      type="blog_image"
                      url={image}
                      urlType="image"
                      requiredWidth={1200}
                      requiredHeight={650}
                      onFileUpload={(url) => {
                        setImage(url);
                        clearErrors("image");
                      }}
                      onInvalidFile={(msg) =>
                        setError("image", {
                          type: "manual",
                          message: msg || "Image format not supported",
                        })
                      }
                      showPreview={false}
                      buttonText="Upload Image"
                    />
                    <ReusableField
                      label="Image URL"
                      name="image"
                      type="text"
                      value={image}
                      onChange={(e) => setImage(e.target.value)}
                      fullWidth={true}
                      error={!!errors.image}
                      helperText={
                        errors.image?.message || (
                          <span>
                            <span style={{ color: "#d32f2f" }}>*</span> Image
                            size: (1200 x 650) px
                          </span>
                        )
                      }
                    />
                  </Box>
                </Card>
              </Grid>
              <Dialog
                open={openLinkModal}
                onClose={() => setOpenLinkModal(false)}
              >
                <DialogTitle>Insert Link</DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    label="URL"
                    type="url"
                    fullWidth
                    value={linkUrl}
                    onChange={(e) => setLinkUrl(e.target.value)}
                    placeholder="https://example.com"
                  />
                  <TextField
                    margin="dense"
                    label="Display Text"
                    type="text"
                    fullWidth
                    value={linkText}
                    onChange={(e) => setLinkText(e.target.value)}
                    placeholder="Enter text to display"
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setOpenLinkModal(false)}>
                    Cancel
                  </Button>
                  <Button onClick={handleInsertLink}>OK</Button>
                </DialogActions>
              </Dialog>

              <Grid item size={{ md: 12 }}>
                <Typography sx={{ mb: 1 }}>Description</Typography>
                <Box sx={{ ".rsw-ce": { minHeight: 150 } }}>
                  <EditorProvider>
                    <Editor
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    >
                      <Toolbar>
                        {/* <BtnStyles />      Adds Heading 1, Heading 2, Paragraph, etc. */}
                        <BtnBold />
                        <BtnItalic />
                        <BtnUnderline />
                        <BtnBulletList />
                        <BtnNumberedList />
                        <BtnUndo />
                        <BtnRedo />
                        <IconButton
                          onClick={handleOpenLinkModal}
                          size="small"
                          color="black"
                        >
                          <LinkIcon />
                        </IconButton>
                        {/* <BtnLink /> */}

                        <BtnClearFormatting />
                        <BtnStyles />
                        <HtmlButton />
                      </Toolbar>
                    </Editor>
                  </EditorProvider>
                </Box>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Button
            size="large"
            type="submit"
            variant="contained"
            sx={{ px: 5, py: 1.5, fontSize: "1rem", borderRadius: "8px" }}
            disabled={isLoading === "caseStudyData"}
          >
            Save & Publish
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default AddBlog;
